// This file is AUTOGENERATED, do not edit it manually!!!

export const common = {
    activity: 'Активность',
    add_check_list_item_placeholder: 'Добавить элемент чек-листа или используйте Ctrl+V для вставки списка',
    add_checklist_label: 'Добавить чек-лист',
    add_more: 'Добавить',
    add_reaction_title: 'Добавить реакцию ',
    ai: 'ИИ',
    ai_analyzing: 'Анализ закономерностей',
    ai_building: 'Построение модели прогнозирования',
    ai_description: 'ИИ-Прогноз от {brandName} использует алгоритмы машинного обучения для поиска закономерностей и зависимостей между событиями и действиями в исторических данных вашего аккаунта. В результате вам будет предложена наиболее вероятная дата окончания проекта.',
    ai_forecast: 'ИИ-Прогноз',
    ai_forecast_date: 'Дата окончания согласно ИИ-Прогнозу',
    ai_how_works: 'Подробнее об ИИ-Прогнозе',
    ai_not_enough_data: 'Исторических данных недостаточно для составления надежного прогноза. Активное использование системы обеспечит более точные результаты прогноза. Подробнее см. <a href={0} target=\'_blank\' class={1}>здесь</a>.',
    ai_planned_date: 'Плановая дата окончания проекта',
    ai_result: 'Результаты ИИ-Прогноза',
    ai_reviewing: 'Обработка исторических данных',
    apply: 'Применить',
    available: 'Доступно',
    back: 'Назад',
    CanChangeWorkflowForProjectOutdatedData: 'Рабочий процесс уже применен к проекту. Пожалуйста, обновите страницу, чтобы актуализировать данные.',
    CanDeleteCategoryHasTask: 'Нельзя удалить категорию, которая используется в существующих задачах.',
    CanDeletePriorityHasProject: 'Нельзя удалить приоритет, который используется в существующих проектах.',
    CanDeletePriorityHasTask: 'Нельзя удалить приоритет, который используется в существующих задачах.',
    CanDeletePriorityIsInternal: 'Нельзя удалить встроенный приоритет.',
    CanDeleteStatusIsWorkflowTypeStatus: 'Нельзя удалить статус по умолчанию.',
    CanDeleteStatusUsed: 'Нельзя удалить статус, который используется в существующих сущностях.',
    CanDeleteThresholdIsInternal: 'Нельзя удалить порог, предустановленный в системе.',
    CanDeleteVacationTypeDefault: 'Нельзя удалить тип отпуска, используемый по умолчанию.',
    CanDeleteVacationTypeHasVacation: 'Нельзя удалить тип, используемый в существующем отпуске.',
    CanDeleteWorkflowIsSingle: 'В системе должен быть хотя бы один рабочий процесс.',
    CanDeleteWorkflowIsUsed: 'Нельзя удалить рабочий процесс, который используется в существующих проектах.',
    CanDisableStatusIsUsed: 'Нельзя отключить статус, который используется в существующих сущностях.',
    CanDisableStatusIsWorkflowTypeStatus: 'Нельзя отключить статус по умолчанию.',
    CanEdit_Task_AccessDenied: 'У Вас нет прав на редактирование этой задачи',
    CanEditValueThresholdIsInternal: 'Нельзя редактировать предустановленные значения порога нагрузки.',
    CanSetWorkflowTypeStatusIsWorkflowTypeStatus: 'Нельзя сделать статус статусом по умолчанию другого типа.',
    change: 'изменить',
    ChangeProjectProgressError: 'Нельзя поменять прогресс проекта, у которого есть задачи.',
    ChangeTaskProgressError: 'Нельзя поменять прогресс родительской задачи.',
    check_all_label: 'Выбрать все',
    checklist_name: 'Чек-лист',
    column_group_custom_fields: 'Дополнительные поля',
    column_group_custom_fields_user: 'Дополнительные поля для пользователя',
    columns: 'Колонки',
    Completed_Projects: 'Завершенные Проекты',
    Completed_Tasks: 'Завершенные Задачи',
    Copy_Text: 'Копия',
    copyPostfix: 'Копия',
    create: 'Создать',
    created_by: 'Создатель',
    creation_date: 'Дата создания',
    current_plan: 'Текущий план: <b>{0}</b>',
    dates: 'Даты',
    delete_checklist_label: 'Удалить чек-лист',
    description_title: 'Описание',
    edit_check_list_item_placeholder: 'Редактировать элемент чек-листа',
    Edit_Text: 'Редактировать',
    emoji: 'Эмодзи',
    empty_list: 'Ничего не найдено для поискового запроса/выбранного фильтра',
    error_reload: 'Версия {brandName} была обновлена. Для корректной работы приложения нужно перезагрузить страницу.',
    export: 'Экспорт',
    export_csv: 'Экспорт в CSV',
    export_pdf: 'Экспорт в PDF',
    filters: 'Фильтры',
    freeze: 'Закрепить столбец',
    from: 'С',
    general: 'Общее',
    global_search: 'Поиск',
    global_search_text: 'Поиск сообщений, файлов и др.',
    GotIt: 'Окей',
    group_by: 'Группировать по',
    group_by_template: 'Группировать по: {0}',
    here: 'здесь',
    hourly_rate_unit: '/чс',
    icons: 'Иконки',
    in: 'в',
    in_use: 'Используется',
    items_text: '7#{0} элемент#{0} элемента#{0} элементов',
    job_role: 'Должность',
    label_custom_date_range: 'Диапазон дат',
    label_daily: 'По дням',
    label_monthly: 'По месяцам',
    label_weekly: 'По неделям',
    label_yearly: 'По годам',
    least_likely: 'Наименее вероятная',
    month: 'Месяц',
    MoreActions: 'Больше действий',
    most_likely: 'Наиболее вероятная',
    move_down: 'Переместить вниз',
    move_up: 'Переместить вверх',
    name_title: 'Имя',
    next_month: 'Следующий месяц',
    next_week: 'Следующая неделя',
    no: 'Нет',
    no_available_filters: 'Нет значений для фильтра',
    no_data_to_display: 'Нет данных для отображения',
    no_data_to_display_for_widget: 'Нет данных для отображения. Фильтры, включая как специфичные для виджетов, так и общие фильтры, могут предотвращать отображение данных.',
    NoPermissionToArchiveProject: 'Запрашиваемое действие (архивирование проекта) недоступно по следующей причине: У вас нет разрешения архивировать проект.',
    not_calculated: 'Не рассчитано',
    not_in_use: 'Не используется',
    pause: 'Пауза',
    PortfolioLimitError: 'Вы достигли лимита в 60 портфолио в Team Edition. Пожалуйста, обновитесь до {brandName} Enterprise Edition.',
    previous_month: 'Предыдущий месяц',
    previous_week: 'Предыдущая неделя',
    previous_year: 'Предыдущий год',
    quarter: 'Квартал',
    quick_search_placeholder: 'Поиск по имени или id',
    quick_search_placeholder_for_archive: 'Поиск архивных проектов по имени или id',
    RateLimitExceededByAccount: 'Извините за неудобства, но из-за высокой нагрузки мы в настоящее время ограничиваем количество запросов, которые вы можете предпринять. Пожалуйста, попробуйте позже.',
    RateLimitExceededByUser: 'Извините за неудобства, но из-за высокой нагрузки мы в настоящее время ограничиваем количество запросов, которые вы можете предпринять. Пожалуйста, попробуйте позже.',
    read_more: 'Подробнее',
    RecordConversionToActivityDifferentWorkflows: 'Невозможно сконвертировать запись, так как разные рабочие процессы применены к проекту и шаблону.',
    records: 'Записи',
    remove_checklist_item_label: 'Удалить элемент чек-листа',
    request_resources: 'Запросить ресурсы',
    reset_timer_title: 'Сбросить таймер',
    resource_type_label: 'Тип ресурса',
    resume: 'Вознобновить',
    role: 'Роль',
    schedule_hours: 'Распределить часы',
    security_group: 'Уровень доступа',
    select: 'Выбрать',
    share: 'Открыть всем',
    short_quarter0: '1-й кв.',
    short_quarter1: '2-й кв.',
    short_quarter2: '3-й кв.',
    short_quarter3: '4-й кв.',
    show: 'Показать',
    show_template: 'Показаны: {0}',
    skillsDeleteConfirm: 'Данный навык будет удалён со всех профилей пользователей и должностей, где он используется',
    SnapshotsLimitError: 'Вы достигли лимита в 3 снимка проекта. Пожалуйста, обновитесь до {brandName} Enterprise Edition.',
    sort: 'Сортировка',
    sort_activities: 'Сортировать задачи по:',
    sort_ascending: 'Сортировать по возрастанию',
    sort_az: 'Сортировать А→Я',
    sort_descending: 'Сортировать по убыванию',
    sort_projects: 'Сортировать проекты по:',
    sort_resources: 'Сортировать ресурсы по:',
    sort_za: 'Сортировать Я→А',
    start: 'Старт',
    start_analyze: 'Начать Анализ',
    start_new_project: 'Начать Новый Проект',
    stop_timer_title: 'Остановить таймер',
    sub_features_list_title: 'Эта функциональность включает:',
    SystemTaskCreatorName: 'Система',
    Task_CanAccessBillingInformation_AccessDenied: 'У Вас нет прав на редактирование настроек биллинга задачи',
    this_month: 'Текущий месяц',
    this_week: 'Текущая неделя',
    this_year: 'Текущий год',
    ThresholdValueDuplicate: 'Данное значение порога нагрузки уже было  добавлено.',
    TimeoutErrorMessage: 'Время ожидания запроса истекло. Пожалуйста, попробуйте позже.',
    to: 'По',
    today: 'Сегодня',
    uncheck_all_label: 'Снять все',
    unfreeze: 'Снять закрепление столбца',
    UnknownErrorMessage: 'Просим прощения, произошла ошибка... Пожалуйста, обновите страницу.',
    update_date: 'Дата обновления',
    updated_by: 'Обновлено',
    upgrade: 'Обновить',
    upgrade_to_enterprise: 'Обновитесь до Enterprise.',
    usage: 'Использование',
    week: 'Неделя',
    year: 'Год',
    yes: 'Да',
    yesterday: 'Вчера',
};
